// TODO - Type 'any' needs to be fixed.
export const setEndReducer = (state: any, action: any) => {
    state.endDate = action.payload
}